import {
    Button,
    createButton,
    IButtonBusinessLogic,
} from '@vfde-brix/ws10/button';
import { BASKET_BUTTON } from '../container/App/constants';
import { startAppListening } from '../container/App/listener';
import { useDispatch } from '../store';
import {
    goToBasket,
    selectHasError,
} from '../container/App/slice';

/**
 * Mount button
 */
export default function mountButton (id: string, business: IButtonBusinessLogic, dom = document): Button | null {
    const container = dom.getElementById(id);

    return container && createButton(container, business);
}

/**
 * Mount basket button
 */
export const mountBasketButton = (): Button | null => {
    const dispatch = useDispatch();

    const button = mountButton(BASKET_BUTTON, {
        onClick: (event: Event) => {
            event.preventDefault();
            dispatch(goToBasket());
        },
    });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectHasError(currentState) !== selectHasError(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            button?.update({
                optDisabled: selectHasError(api.getState()),
            });
        },
    });

    return button;
};
